import { useMutation } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';
import type {
  UnacceptMatchesAPInvoiceInput,
  UnacceptMatchesAPInvoiceResponse,
} from '@erp/rpc';
import { useToast } from '@/context/ToastContext';

export interface UseUnacceptAPInvoiceOptions {
  onSuccess?: (
    data: UnacceptMatchesAPInvoiceResponse,
    variables: UnacceptMatchesAPInvoiceInput,
  ) => void;
}

export function useUnacceptAPInvoice(options?: UseUnacceptAPInvoiceOptions) {
  const invalidateRpcQueryFn = useInvalidateRpcQueryFn(
    (orpc, { id }: { id: string }) => [
      orpc.accountsPayable.invoices.get.queryKey({ input: { id } }),
      orpc.accountsPayable.invoices.list.queryKey({ input: {} }),
    ],
  );
  const { showToast } = useToast();

  return useMutation(
    orpc.accountsPayable.invoices.unacceptMatches.mutationOptions({
      onSuccess: (data, variables) => {
        showToast({
          title: 'Success',
          message: 'Invoice reverted successfully',
          color: 'success',
          icon: 'check',
        });

        invalidateRpcQueryFn({ id: variables.id });

        options?.onSuccess?.(data, variables);
      },
      onError: (error) => {
        showToast({
          title: 'Error',
          message: error.message || 'Failed to revert invoice',
          color: 'error',
          icon: 'x',
        });
      },
    }),
  );
}
